import { MenuComposer } from './menu';
import * as SalesStore from '../SalesStore';

import { Permission, TicketLineDTO, ProductForSaleDTO, MenuForSaleDTO } from 'core/api';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { CatalogueFacade, RestaurantFacade } from 'pos/facades';
import { Command } from 'pos/common';
import { CustomerDisplay } from 'pos/services';
import { Modal } from 'core/ui-next/modal';

import { composeProductForMenu, MenuWizardScreen } from './menu';

async function getComposition(menu: MenuForSaleDTO, menuHeader: TicketLineDTO) {
	return await MenuComposer.build({
		menu,
		menuHeader: menuHeader
	}, SalesStore.getTicket, CatalogueFacade.getSaleableAsMenuItemByProductGroup);
}

async function composeMenu(menuHeader: TicketLineDTO, mode: 'new' | 'edition'): Promise<Result> {

	const menu = await CatalogueFacade.getMenuForSale(menuHeader.Product.SaleFormatId);

	let composition = await getComposition(menu, menuHeader);

	const addProduct = async (composition: MenuComposer.Composition, product: ProductForSaleDTO, quantity: number): Promise<Result> => {

		const result = await composeProductForMenu(product, composition, quantity);
		if (!result.ok)
			return Result.error();

		const addLineResult = SalesStore.addLines(result.value);
		await CustomerDisplay.displayNewLine(SalesStore.getTicket(), SalesStore.getTicket().Lines.last());
		return addLineResult;
	};

	// Evito autocompletar si es una edición, porque puede ser que se haya autocompletado el menú y ahora queramos forzar a que
	// salga la pantalla para modificar algo sobre él
	if (mode === 'new') {
		composition = await MenuComposer.tryToComplete(composition, SalesStore.getTicket, CatalogueFacade.getSaleableAsMenuItemByProductGroup, addProduct);
		if (MenuComposer.isCompleted(composition, SalesStore.getTicket))
			return Result.ok();
	}

	const profile = await RestaurantFacade.getDisplayProfile();
	composition = await MenuComposer.getNextNotCompletedRole(composition, SalesStore.getTicket, CatalogueFacade.getSaleableAsMenuItemByProductGroup);
	return Modal.show(MenuWizardScreen, { initialComposition: composition, buttonSize: profile.ButtonSize });
}

declare global {
	interface CommandType {
		composeMenu: (menuHeader: TicketLineDTO, mode: 'new' | 'edition') => Promise<Result>
	}
}

Command.register('composeMenu', Preconditions.ensure(Permission.Ticket_ComposeProduct), composeMenu);
